import { PageOne } from './src/PageOne.js';

window.customElements.define('page-one', PageOne);
